import React from 'react'
import Camera from '../camera/Camera'

export default props => <Camera subdir='images' />
